import { EStandard } from './enums/EStandard'

export const TELEMETRY_PACKET_DELIMITER = '$'

export function getStandard(content: string): EStandard | null {
    if (content.includes(TELEMETRY_PACKET_DELIMITER)) {
        return EStandard.telemetry
    }

    if (content.includes('Start of log') || content.includes('ms,')) {
        return EStandard.sdCard
    }

    if (content.includes('Simulator')) {
        return EStandard.simulator
    }

    return null
}
